<template>
  <div class="calendar">
    <div class="head">
      <span class="date">{{curYear + "年" + curMonth + "月"}}</span>
      <div class="btn">
        <i class="ivu-icon ivu-icon-ios-arrow-back" @click="onPreMonth"></i>
        <i class="ivu-icon ivu-icon-ios-arrow-forward" @click="onNextMonth"></i>
      </div>
    </div>
    <div class="body">
      <div class="title">
        <div class="cell" v-for="(item, index) in titleList" :key="index">{{item}}</div>
      </div>
      <div class="day">
        <div
          class="cell"
          :class="{pointer: item!==0}"
          v-for="(item, index) in dayList"
          :key="index"
          @click="onClickDay(item)"
        >
          <span
            v-if="item!==0"
            class="text"
            :class="{
              today: item.isToday,
              select: item.day == selectDay,
              'has-data': hasData(item.date),
              'allow-action': allowAction(item.date)
              }"
          >{{item.day}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "calendar",
  props: {
    startDay: {
      type: String
    },
    calendarDate: {
      //含有课程的日期集合 如['2019-8-1', '2019-8-15']
      type: Array,
      default() {
        return [];
      }
    },
    calendarAllowDate: {
      //允许操作的日期集合 如['2019-8-1', '2019-8-15']
      type: Array,
      default() {
        return [];
      }
    },
    firstDay: {
      //周起始日 1到7
      type: Number,
      default: 1,
      validator(val) {
        if (val >= 1 && val <= 7) {
          return true;
        }
        return false;
      }
    }
  },
  computed: {
    calendarDateSet() {
      const retAry = [];
      this.calendarDate.forEach(i => {
        retAry.push(new Date(i.replace(/-/g, "/")));
      });
      return retAry;
    }
  },
  data() {
    return {
      event: {
        onCurDate: "onCurDate", //当前日期，初始化时返回
        onChangeDate: "onChangeDate", //日期改变
        onClickDay: "onClickDay" //点击日期
      },
      curYear: 2019, //当前年份
      curMonth: 8, //当前月份
      titleList: ["一", "二", "三", "四", "五", "六", "日"],
      dayList: [],
      dayOfMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      selectDay: 0,
      nowDate: new Date(this.startDay)
    };
  },
  created() {
    // init props
    const tmpAry = this.titleList.splice(0, this.firstDay - 1);
    this.titleList = this.titleList.concat(tmpAry);

    this.nowDate = new Date(this.$route.query.date * 1000);
    // init date
    this.init(this.nowDate);
    this.selectDay = this.nowDate.getDate();
    this.$emit(
      this.event.onCurDate,
      this.startDay
    );
  },
  methods: {
    // on event
    onPreMonth() {
      this.curYear = this.curMonth - 1 <= 0 ? this.curYear - 1 : this.curYear;
      this.curMonth = this.curMonth - 1 <= 0 ? 12 : this.curMonth - 1;
      this.selectDay = 0;
      this.init(new Date(`${this.curYear}/${this.curMonth}/1`));
      this.$emit(this.event.onChangeDate, `${this.curYear}-${this.curMonth}-1`);
    },
    onNextMonth() {
      this.curYear = this.curMonth + 1 > 12 ? this.curYear + 1 : this.curYear;
      this.curMonth = this.curMonth + 1 > 12 ? 1 : this.curMonth + 1;
      this.selectDay = 0;
      this.init(new Date(`${this.curYear}/${this.curMonth}/1`));
      this.$emit(this.event.onChangeDate, `${this.curYear}-${this.curMonth}-1`);
    },
    onClickDay(item) {
      this.selectDay = item.day;
      this.$emit(
        this.event.onClickDay,
        `${this.curYear}-${this.curMonth}-${item.day}`
      );
    },
    // other
    init(date) {
      // current
      this.curYear = date.getFullYear();
      this.curMonth = date.getMonth() + 1;
      // day of month
      if (this.isLeapYear(date.getFullYear())) {
        this.dayOfMonth[1] = 29;
      }
      // day list
      const year = date.getFullYear(),
        month = date.getMonth();
      const dayList = [];
      this.dayList = [];
      const dayCount = this.dayOfMonth[month];
      let firstDayWeek = new Date(year, month, 1).getDay();
      firstDayWeek = firstDayWeek == 0 ? 7 : firstDayWeek;
      firstDayWeek = (firstDayWeek - this.firstDay + 7) % 7;
      for (let i = 1; i <= firstDayWeek; ++i) {
        dayList.push(0);
      }
      for (let i = 1; i <= dayCount; ++i) {
        dayList.push(i);
      }
      for (const i of dayList) {
        if (i == 0) {
          this.dayList.push(i);
        } else {
          const date = new Date(year, month, i);
          this.dayList.push({
            date,
            day: i,
            isToday: this.isDateEqual(date, new Date())
          });
        }
      }
    },
    isLeapYear(year) {
      if (year % 100 == 0) {
        return year % 400 == 0;
      }
      return year % 4 == 0;
    },
    isDateEqual(date1, date2) {
      if (
        date1.getFullYear() == date2.getFullYear() &&
        date1.getMonth() == date2.getMonth() &&
        date1.getDate() == date2.getDate()
      ) {
        return true;
      }
      return false;
    },
    hasData(date) {
      for (const i of this.calendarDateSet) {
        if (this.isDateEqual(i, date)) {
          return true;
        }
      }
      return false;
    },

    allowAction(date) {
      let curTime = parseInt(date.getTime()/1000)
      if ( curTime >= this.calendarAllowDate[0] && curTime <= this.calendarAllowDate[1]) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.calendar {
  background-color: #fff;
  padding: 20px 0 16px 0;
  .head {
    font-size: 26px;
    color: #595959;
    text-align: left;
    margin-bottom: 25px;
    .date {
      margin: 0 25px;
    }
    .btn {
      float: right;
    }
  }
  .body {
    .cell {
      width: 14.28%;
      height: 45px;
      display: block;
      float: left;
      text-align: center;
      position: relative;
    }
    .pointer {
      cursor: pointer;
    }
    .title {
      font-size: 12px;
      color: #8c8c8c;
      &::after {
        content: "";
        display: block;
        clear: both;
      }
    }
    .day {
      font-size: 17px;
      color: #595959;
      position: relative;
      .today {
        color: #fff;
        background-color: #2b83f9;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      .allow-action{
        position: relative;
        color: #fff;
        background-color: #2b83f9;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      .has-data {
        position: relative;
        color: #fff;
        background-color: green;
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }
      .select {
        color: #595959;
        background-color: #fff;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        border: 1px solid #595959;
      }
      .text {
        display: inline-block;
        line-height: 32px;
      }
      &::after {
        content: "";
        display: block;
        clear: both;
      }
    }
  }
}
</style>
